export function SkipLink() {
  return (
    <a
      href="#main-content"
      className={[
        "sr-only",
        "focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[9999]",
        "focus:px-4 focus:py-2 focus:rounded-lg focus:bg-brand-600 focus:text-white",
        "focus:font-semibold focus:shadow-lg focus:outline-none",
      ].join(" ")}
    >
      Skip to main content
    </a>
  );
}
